import axios from 'axios';
import { useAtom } from 'jotai';
import { useSnackbar } from 'notistack';
import { bootstrapInfos } from 'store/public/bootstrapInfo';

const useImageKey = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [getBootstrapInfos] = useAtom(bootstrapInfos);

  const imageRequest = (image, insertRequest, setInsertLoading) => {
    axios
      .post(
        getBootstrapInfos
          ? `${getBootstrapInfos['server-download']}/Uploader/Process`
          : '/',
        image,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then(res => {
        if (res.status === 200) {
          insertRequest(res.data);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
          setInsertLoading(false);
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
        setInsertLoading(false);
      });
  };
  return [imageRequest];
};

export default useImageKey;
